import classnames from 'classnames';

import { useColorScheme } from 'redesignedComponents/context/colorScheme';

import { BannerBlockCarouselProps } from './types';

import useStyles from './styles';

const BannerBlockCarouselFallback = ({ carouselItems, title }: BannerBlockCarouselProps) => {
  const colorScheme = useColorScheme();

  const styles = useStyles({ colorScheme });
  return (
    <div className={styles.skeletonRoot}>
      {title && <i className={classnames('skeleton', styles.skeletonTitle)} />}
      {carouselItems && (
        <div className={styles.skeletonWrapper}>
          <div>
            <i className={classnames('skeleton', styles.skeletonItemTitle)} />
            <i className={classnames('skeleton', styles.skeletonItemDescription)} />
          </div>
          <div>
            <i className={classnames('skeleton', styles.skeletonItemImage)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BannerBlockCarouselFallback;
